import { isKashuApp } from "@/lib/utils";
import { LogoIcon } from "@/components/ui/icons";
import { useLoaderData } from "@tanstack/react-router";
import useGetWhiteLabelLogo from "@/features/white-label-logo/useGetWhiteLabelLogo";

interface PulsingKashuLogoProps {
	size?: number; // diameter in px for the white circle, icon will scale accordingly
}

function WhiteLabelLogo({ size = 160 }: PulsingKashuLogoProps) {
	// The white circle is size, the green pulse is 1.5x, the icon is 0.5x
	const iconSize = size * 0.5;
	const pulseSize = size * 1.5;
	const pulseOffset = (pulseSize - size) / 2;

	const { logo } = useLoaderData({ from: "__root__" });
	const { data: logoSrc } = useGetWhiteLabelLogo({ logoPath: logo });

	return (
		<div className="relative m-10">
			<div
				className="bg-white rounded-full z-20 relative flex items-center justify-center"
				style={{ width: size, height: size, padding: size * 0.0625 }}
			>
				{isKashuApp() ? (
					<LogoIcon width={iconSize} height={iconSize} />
				) : (
					logoSrc && (
						<img
							src={logoSrc}
							alt="Brand Logo"
							className="block max-w-16 w-16 aspect-square h-16 object-contain"
						/>
					)
				)}
			</div>
			<div
				className="bg-primary-400 rounded-full absolute animate-pulseCustom z-10"
				style={{
					width: pulseSize,
					height: pulseSize,
					top: -pulseOffset,
					left: -pulseOffset,
					padding: size * 0.125,
				}}
			></div>
		</div>
	);
}

export default WhiteLabelLogo;
